export default __webpack_public_path__ + "static/media/hex.f469927f.svg";